module.exports = __webpack_public_path__ + "static/media/right_sustain.9357498e.png";